
import EyeSlash from "../../../assets/filled/EyeSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EyeSlashIcon({ className, dataTestid = "EyeSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EyeSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
